/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdCampaignErrorDataSchema = z.object({
	id: z.string(),
	errorMessage: z.string(),
	createdAt: z.iso.datetime(),
})

export type MetaAdCampaignErrorDataSchema = z.infer<typeof metaAdCampaignErrorDataSchema>
